import {
    createUnitFeaturesDecoder,
    UnitFeatures,
    unitFeaturesDecoder,
    updateNightlyRatesDecoder,
} from '@codecs/revenueEstimate';
import { environment } from '@lib/environment';
import { NightlyRates } from '@models/NightlyRates';
import { jsonapiCreate, jsonapiGet, jsonapiUpdate } from '@vacasa/jsonapi';
import axios from 'axios';
import { createCancelToken } from './cancelToken';

export async function getUnitFeatures(unitId: string): Promise<UnitFeatures | undefined> {
    const url = `/v1/revenue-estimate/features/${unitId}`;
    return await jsonapiGet({
        baseURL: environment.REACT_APP_API_URL(),
        url,
        cancelToken: createCancelToken('getUnitFeatures'),
        decoder: unitFeaturesDecoder,
    })
        .then((response) => {
            return response.data.data.attributes;
        })
        .catch((err) => {
            if (!axios.isCancel(err)) {
                console.error(`GET ${url} failed`, err);
            }
            return undefined;
        });
}

export async function saveUnitFeatures(
    unitId: string,
    features: Pick<UnitFeatures, 'address' | 'bathrooms' | 'bedrooms'>,
) {
    const url = `/v1/revenue-estimate/features/${unitId}`;
    return await jsonapiCreate({
        baseURL: environment.REACT_APP_API_URL(),
        url,
        cancelToken: createCancelToken('saveUnitFeatures'),
        decoder: createUnitFeaturesDecoder,
        data: {
            data: {
                id: unitId,
                type: 'revenue-estimate',
                attributes: { ...features },
            },
        },
    })
        .then((response) => response.data.data.attributes)
        .catch((err) => {
            if (!axios.isCancel(err)) {
                console.error(`POST ${url} failed`, err);
            }
            return undefined;
        });
}

export async function updateUnitFeatures(unitId: string, features: UnitFeatures) {
    const url = `/v1/revenue-estimate/features/${unitId}`;
    return await jsonapiUpdate({
        baseURL: environment.REACT_APP_API_URL(),
        url,
        cancelToken: createCancelToken('updateUnitFeatures'),
        decoder: unitFeaturesDecoder,
        data: {
            data: {
                id: unitId,
                type: 'revenue-estimate',
                attributes: { ...features },
            },
        },
    })
        .then((response) => response.data.data.attributes)
        .catch((err) => {
            if (!axios.isCancel(err)) {
                console.error(`PATCH ${url} failed`, err);
            }
            return undefined;
        });
}

export async function updateNightlyRates(unitId: string, nightlyRates: NightlyRates) {
    const url = `/v1/revenue-estimate/features/${unitId}/nightly-rates`;
    return await jsonapiUpdate({
        baseURL: environment.REACT_APP_API_URL(),
        url,
        cancelToken: createCancelToken('updateNightlyRates'),
        decoder: updateNightlyRatesDecoder,
        data: {
            data: {
                id: unitId,
                type: 'revenue-estimate',
                attributes: { nightlyRates },
            },
        },
    })
        .then((response) => response.data.data.attributes)
        .catch((err) => {
            if (!axios.isCancel(err)) {
                console.error(`PATCH ${url} failed`, err);
            }
            return undefined;
        });
}
